var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-area" },
    [
      _c(
        "div",
        { staticClass: "title-2", staticStyle: { "margin-bottom": "15px" } },
        [_vm._v("采集异常学生筛查")]
      ),
      _c(
        "a-tabs",
        {
          attrs: { "active-key": _vm.tabKey },
          on: { change: _vm.handleTabChange },
        },
        _vm._l(_vm.tabPaneConfig, function (item) {
          return _c(
            "a-tab-pane",
            { key: item.key, attrs: { tab: item.tab } },
            [
              _c(
                "TableList",
                {
                  staticStyle: { "min-height": "350px" },
                  attrs: {
                    columns: _vm.columns,
                    tableData: _vm.dataSource,
                    scroll: {},
                    bordered: "",
                    loading: _vm.loading,
                    pagination: _vm.ipagination,
                  },
                  on: { change: _vm.handleTableChange },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "labelsList",
                        fn: function ({ record }) {
                          return _c(
                            "div",
                            { staticClass: "flex-align-center" },
                            _vm._l(record.labelsList, function (item, index) {
                              return _c(
                                "span",
                                {
                                  key: index,
                                  staticClass: "label-item",
                                  style: {
                                    color: _vm.getStuTagColorConfig(item.key)
                                      .color,
                                    background: _vm.getStuTagColorConfig(
                                      item.key
                                    ).bgColor,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.text) +
                                      "\n          "
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        },
                      },
                      {
                        key: "noCollectReason",
                        fn: function ({ record }) {
                          return [
                            record.noCollectReason &&
                            record.noCollectReason.length >= 15
                              ? _c(
                                  "a-tooltip",
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(_vm._s(record.noCollectReason)),
                                    ]),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          record.noCollectReason.substring(
                                            0,
                                            15
                                          ) + "..."
                                        ) +
                                        "\n          "
                                    ),
                                  ],
                                  2
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(record.noCollectReason)),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "operation",
                        fn: function ({ record }) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "#1890ff",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewDetail(record)
                                  },
                                },
                              },
                              [_vm._v("查看详情")]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "query-area",
                      attrs: { slot: "queryArea" },
                      slot: "queryArea",
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("j-dict-select-tag", {
                            staticStyle: {
                              width: "170px",
                              "margin-right": "15px",
                            },
                            attrs: {
                              placeholder: "请选择年级",
                              dictCode:
                                "school_grade,grade_name,id,0=delete_flag order by sort_order",
                              isShowEmpty: false,
                            },
                            on: {
                              select: function ($event) {
                                return _vm.$set(
                                  _vm.queryParam,
                                  "classId",
                                  undefined
                                )
                              },
                              clear: function ($event) {
                                return _vm.$set(
                                  _vm.queryParam,
                                  "classId",
                                  undefined
                                )
                              },
                            },
                            model: {
                              value: _vm.queryParam.gradeId,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "gradeId", $$v)
                              },
                              expression: "queryParam.gradeId",
                            },
                          }),
                          _c("j-dict-select-tag", {
                            staticStyle: {
                              width: "170px",
                              "margin-right": "15px",
                            },
                            attrs: {
                              placeholder: "请选择班级",
                              dictCode:
                                "school_class,name,id,grade_id=" +
                                (!_vm.queryParam.gradeId
                                  ? -1
                                  : _vm.queryParam.gradeId),
                              async: true,
                              disabled: !_vm.queryParam.gradeId,
                              isShowEmpty: false,
                            },
                            model: {
                              value: _vm.queryParam.classId,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "classId", $$v)
                              },
                              expression: "queryParam.classId",
                            },
                          }),
                          _c("a-input-search", {
                            staticClass: "search-space",
                            staticStyle: { width: "170px" },
                            attrs: { placeholder: "请输入学生名字" },
                            on: { change: _vm.searchName },
                            model: {
                              value: _vm.queryParam.studentName,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "studentName", $$v)
                              },
                              expression: "queryParam.studentName",
                            },
                          }),
                          _vm.tabKey != 2
                            ? _c("a-range-picker", {
                                staticStyle: {
                                  width: "220px",
                                  "margin-right": "15px",
                                },
                                attrs: {
                                  getCalendarContainer: (node) =>
                                    node.parentNode,
                                },
                                on: { change: _vm.changeDateRange },
                                model: {
                                  value: _vm.dateRange,
                                  callback: function ($$v) {
                                    _vm.dateRange = $$v
                                  },
                                  expression: "dateRange",
                                },
                              })
                            : _vm._e(),
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.queryTable },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "a-button",
                            {
                              staticStyle: { "margin-left": "15px" },
                              attrs: { type: "primary", icon: "reload" },
                              on: { click: _vm.searchReset },
                            },
                            [_vm._v("\n              重置\n            ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "a-popconfirm",
                            {
                              attrs: {
                                title: "确定要一键提醒吗？",
                                "ok-text": "确认",
                                "cancel-text": "取消",
                              },
                              on: { confirm: _vm.oneKeyReminder },
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-right": "15px" },
                                  attrs: {
                                    icon: "alert",
                                    loading: _vm.btnLoading,
                                    type: "primary",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                一键提醒\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-button",
                            {
                              attrs: {
                                icon: "download",
                                loading: _vm.exportXlsLoading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleExportXls(item.tab)
                                },
                              },
                            },
                            [_vm._v("\n              导出\n            ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }